import { render } from "./EmailForm.vue?vue&type=template&id=30d65bd4&scoped=true&ts=true"
import script from "./EmailForm.vue?vue&type=script&lang=ts"
export * from "./EmailForm.vue?vue&type=script&lang=ts"

import "./EmailForm.vue?vue&type=style&index=0&id=30d65bd4&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d65bd4"]])

export default __exports__